var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 21",
    style: {
      enableBackground: "new 0 0 21 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.25,4.5c0-0.41-0.34-0.75-0.75-0.75S9.75,4.09,9.75,4.5v6c0,0.2,0.08,0.39,0.22,0.53l2.63,2.62 c0.29,0.29,0.77,0.29,1.06,0s0.29-0.77,0-1.06l-2.41-2.41V4.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.5,0C4.7,0,0,4.7,0,10.5C0,16.3,4.7,21,10.5,21C16.3,21,21,16.3,21,10.5C21,4.7,16.3,0,10.5,0z M1.5,10.5 c0-4.97,4.03-9,9-9c4.97,0,9,4.03,9,9c0,4.97-4.03,9-9,9C5.53,19.5,1.5,15.47,1.5,10.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.7417f715df2b2b7d5076c1f23affa877.svg";
export { ForwardRef as ReactComponent };